import { createSlice } from "@reduxjs/toolkit";

const coachSlice = createSlice({
    name:'coach',
    initialState:{
        coach:[]
    },
    reducers: {
        addCoach : (state,action) => {
            state.coach = [...state.coach,action.payload]
        },
        // removeOccupation(){
        //     return state.occupation.filter((item)=> item.id != action.payload);
        // }
    }
});

export const { addCoach } = coachSlice.actions;
export default coachSlice.reducer;